<div class="countdown-timer" [class.compact]="compact()" [class.inverted]="inverted()">
  <div class="countdown-unit">
    <div class="countdown-box">
      <span class="countdown-value">{{ days() }}</span>
    </div>
    <span class="countdown-label">Days</span>
  </div>
  <div class="countdown-unit">
    <div class="countdown-box">
      <span class="countdown-value">{{ hours() }}</span>
    </div>
    <span class="countdown-label">Hours</span>
  </div>
  <div class="countdown-unit">
    <div class="countdown-box">
      <span class="countdown-value">{{ mins() }}</span>
    </div>
    <span class="countdown-label">Mins</span>
  </div>
  <div class="countdown-unit">
    <div class="countdown-box">
      <span class="countdown-value">{{ secs() }}</span>
    </div>
    <span class="countdown-label">Secs</span>
  </div>
</div>
